module.exports = __webpack_public_path__ + "static/media/sitting.0f0ce7b5.png";